const NotFound = () => {
  return (
    <div className="bg-gray text-secondary mx-auto">
      <h1 className="w-1/3 py-10 mx-auto text-4xl"> Page is not found !!</h1>
    </div>
  );
};
export default NotFound;
